import { CmsComponent } from '@spartacus/core'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class BaseConverterService {
  constructor () {
  }

  parseComponentData (source: CmsComponent): CmsComponent {
    return source
  }
}
